import swallowingStyled from '../../../utils/swallowingStyled';
import { SvgImageProps, SvgImagePropsWithTheme } from '../types';

const iconColor = (props: SvgImagePropsWithTheme): string => {
  if (props.color) {
    return props.color;
  }
  if (props.primary) {
    return props.theme.global.primary;
  }
  if (props.red) {
    return props.theme.colors.red.default;
  }
  if (props.light) {
    return props.theme.text.light;
  }

  return 'currentColor';
};

const svgSize = (props: SvgImageProps): string => {
  if (props.size) {
    return `
      width: ${props.size};
      height: ${props.size};
    `;
  }
  return `
      width: ${props.width || '1em'};
      height: ${props.height || '1em'};
    `;
};

const SWALLOWED_PROPS = [
  'width',
  'height',
  'size',
  'rotation',
  'color',
  'primary',
  'red',
  'light',
];

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const Svg = swallowingStyled('svg', SWALLOWED_PROPS)`
  display: inline-block;
  stroke-width: 0;
  transition: transform 0.33s ease;
  ${svgSize} ${(props: SvgImageProps) =>
  props.rotation ? `transform: rotate(${props.rotation}deg);` : ''};

  &.icon {
    fill: ${iconColor};
    stroke: ${iconColor};
  }
`;

export default Svg;
